document.addEventListener("DOMContentLoaded",function(){
    var fileField = document.querySelector("input[type='file']");
    if (fileField) {
        fileField.addEventListener('change', function() {
            validateFiles(this);
        });
    }
});
// http://stevenyue.com/blogs/validate-attachment-file-size-and-type-in-rails/
var validateFiles = function (inputFile) {
    var $ = django.jQuery;
    var extensions = $(inputFile).data('extensions');
    var maxExceededMessage = "This file exceeds the maximum allowed file size (5 MB)";
    var extErrorMessage = "Only image file with extension: ("+extensions+") is allowed";
    var allowedExtension = extensions.split(",");//["jpg", "jpeg", "gif", "png"];
    console.log(allowedExtension);

    var extName;
    var maxFileSize = $(inputFile).data('max-file-size');
    console.log(maxFileSize);

    var sizeExceeded = false;
    var extError = false;

    $.each(inputFile.files, function () {
        if (this.size && maxFileSize && this.size > parseInt(maxFileSize)) {
            sizeExceeded = true;
        }

        extName = this.name.split('.').pop();
        if ($.inArray(extName, allowedExtension) == -1) {
            extError = true;
        }
    });
    if (sizeExceeded) {
        window.alert(maxExceededMessage);
        $(inputFile).val('');
    }

    if (extError) {
        window.alert(extErrorMessage);
        $(inputFile).val('');
    }

}